<template>
<transition name="slide-left">
  <div class='drawer' v-if="$store.state.drawer_show" @click="$store.commit('showDrawer', false)">
    <div class='content'>
      <div class='top'>
        <div @click="$store.commit('showDrawer', false)" class='icon'><img src="../assets/icons/cancel.svg" /></div>
      </div>
      <div class='mid'>
        <div class='menu' v-if="entity" >
          <h3>{{entity.name}}</h3>
          <div v-for='menu in entity.menu' class='menu-item'>
            <router-link :to="menu.link">{{menu.name}}</router-link>
          </div>
        </div>
      </div>
      <div class='bot'>
        <span v-if="$store.state.user">
          {{ $store.state.user.email }} | <a href="javascript:" @click='$store.dispatch("logout")'>Logout</a>
        </span>
      </div>
    </div>
  </div>
</transition>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapState } from 'vuex'
export default {
    name: "Drawer",
    computed: {
        ...mapState(['entity_id']),
        ...mapGetters(['entity'])
    }
}
</script>

<style scoped>
.drawer {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0,0,0,0.5);
    z-index: 1;
}
.content {
    background-color: white;
    box-shadow: 5px 0 10px rgba(0,0,0,0.5);
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    width: 320px;
    display: flex;
    flex-direction: column;
}
.mid {
    flex-grow: 1;
}
.top .icon {
    float: right;
}
.bot {
    padding: 10px;
}
.slide-left-enter-active {
  animation: slide-left-in 0.5s;
}
.slide-left-leave-active {
  animation: slide-left-in 0.5s reverse;
}
@keyframes slide-left-in {
    0% {
        right: -320px;
    }
    100% {
        right: 0;
    }
}
.menu {
    display: flex;
    flex-direction: column;
    overflow: auto;
    padding: 0 20px;
}
.menu .menu-item {
    padding-left: 10px;
}
</style>
